import React from 'react';
import { AlertProps } from 'theme-ui';
import { Box, Alert } from '../core';
import { MouseoverTooltip, TooltipIcon, IIcons } from '../Tooltip';

export const VaultFull = (props: AlertProps): JSX.Element | null => {
  return (
    <MouseoverTooltip
      placement="top"
      width="auto"
      text="Follow us on Twitter or join our Discord to hear first about deposit limit increases."
    >
      <Alert {...props} variant="buttons.disabled">
        <Box m="auto">
          Vault at capacity. <TooltipIcon icon={IIcons.HELP} />
        </Box>
      </Alert>
    </MouseoverTooltip>
  );
};
